<template>
  <div
    id="clockRecords"
    :class="[$route.path.includes('/lishui/clockRecords') ? 'detail' : '']"
  >
    <div class="data-top">
      <div class="item">
        <div class="item-number" style="color: #1989fa">
          <b>{{ clockTimes || '0' }}</b
          ><span> 天 </span>
        </div>
        <div>出勤天数</div>
      </div>
      <div class="item">
        <div class="item-number" style="color: red">
          <b>{{ lateTimes || '0' }}</b
          ><span> 次 </span>
        </div>
        <div>迟到次数</div>
      </div>
      <div class="item">
        <div class="item-number" style="color: red">
          <b>{{ earlyTimes || '0' }}</b
          ><span> 次 </span>
        </div>
        <div>早退次数</div>
      </div>
    </div>
    <div class="r-time">
      <div class="time-length">当月共有{{ listData.length }}天有打卡记录</div>
      <div @click="dateShow = true" class="time-div">
        <span>{{ param.month }}</span>
        <van-icon :name="dateShow ? 'arrow-up' : 'arrow-down'" />
      </div>
      <van-popup v-model="dateShow" position="bottom" round>
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="dateShow = false"
          @confirm="dateConfirm"
          :formatter="formatter"
        />
      </van-popup>
    </div>
    <div class="r-list" v-if="listData && listData.length > 0">
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item
          v-for="(item, index) in listData"
          :key="index"
          :name="index + ''"
        >
          <template #title>
            <div>
              <span>{{ item.days }}</span>
              <span :class="item.punchCardStatus == 1 ? 'e' : 'une'"></span>
            </div>
          </template>
          <!-- <div>共{{item.entityList.length}}次打卡</div> -->
          <div class="weekTime">
            考勤规则：<span v-for="(time, index) in item.weekTime" :key="index"
              >{{ time }}、</span
            >
          </div>
          <div class="weekTime">打卡时间：{{ item.punchRuleTime }}</div>

          <van-steps direction="vertical" active-icon="">
            <van-step
              v-for="(sub, i) in item.punchRecordVoList"
              :key="i"
              :class="
                sub.punchCard
                  ? sub.punchCard.includes('正常')
                    ? 'eStep'
                    : 'uneStep'
                  : ''
              "
            >
              <div class="time">
                <span>{{ sub.punchTime || '-' }}</span>
                <span :class="sub.punchCardStatus == 1 ? 'e' : 'une'">{{
                  sub.punchCard || '-'
                }}</span>
              </div>
              <div v-if="sub.punchCard != '缺卡'">
                <div class="address">
                  <van-icon name="location" />当前位置距离公司<span>{{
                    sub.distance
                  }}</span
                  >米
                </div>
                <div class="address-name">
                  考勤地点：{{ sub.placeName ? sub.placeName : '' }}
                </div>
              </div>
              <div class="distance">
                <van-icon name="location" />{{
                  sub.punchInOff === 1 ? '上班打卡' : '下班打卡' || '-'
                }}
              </div>
            </van-step>
          </van-steps>
          <van-steps direction="vertical" active-icon="">
            <van-step
              class="remark_step"
              v-for="(subs, i) in item.punchRemarks"
              :key="i"
            >
              <div class="remark">
                <div class="time">
                  <span>{{ subs.punchTime || '-' }}</span>
                </div>
                <div>{{ subs.address }} {{ subs.remark }}</div>
                <img
                  v-if="subs.pictUrl"
                  :src="subs.pictUrl"
                  alt="加载失败"
                  @click="imgFuntion(subs.pictUrl)"
                />
                <div class="remark_color">
                  <van-icon name="location" />备注打卡
                </div>
              </div>
            </van-step>
          </van-steps>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-empty description="暂无打卡记录" v-else />
    <div v-if="isOverall" class="situation" @click="isOverall = false">
      <img :src="overall" alt="" />
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { listMyClocked } from '@api/lishui'
import { getLocalStorage, removeLocalStorage } from '@utils'
export default {
  name: 'ClockRecords',
  props: {},
  data() {
    return {
      param: {
        mobile: null,
        creditCode: null,
        month: null
      },
      overall: '',
      isOverall: false,
      clockTimes: 0,
      lateTimes: 0,
      earlyTimes: 0,
      unClockTimes: 0,
      listData: [],
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      dateShow: false,
      minDate: new Date(2020, 12, 30),
      maxDate: new Date(2080, 12, 30),
      currentDate: new Date(),
      activeNames: null,
      creditCodeInCookies: Cookies.get('lishuiCreditCode'),
      mobileInCookies: Cookies.get('lishuiPh')
    }
  },
  created() {
    let info = getLocalStorage('lishuiAdminWatch')
    if (info) {
      let temp = JSON.parse(info)
      this.param.mobile = temp.mobile
      this.param.creditCode = temp.creditCode
      let temp2 = temp.recordDate ? temp.recordDate.split('-') : []
      this.param.month = temp2[0] + '-' + temp2[1]
    } else {
      this.param.mobile = this.userInfo.mobile || this.mobileInCookies
      this.param.creditCode = this.userInfo.creditCode || this.creditCodeInCookies
      let year = new Date().getFullYear()
      let tempMonth = new Date().getMonth() + 1
      this.param.month =
        year + '-' + (tempMonth < 10 ? '0' + tempMonth : tempMonth)
    }
    // 获取打卡记录
    this.getList()
  },
  mounted() { },
  beforeDestroy() {
    removeLocalStorage('lishuiAdminWatch')
  },
  watch: {},
  methods: {
    // 获取打卡记录
    getList() {
      listMyClocked({
        mobile: this.$route.query.mobile || this.param.mobile,
        creditCode: this.param.creditCode,
        month: this.param.month
      }).then(Response => {
        let res = Response.data
        if (res.code == '0000') {
          this.clockTimes = res.data ? res.data.clockTimes : 0
          this.lateTimes = res.data ? res.data.lateTimes : 0
          this.earlyTimes = res.data ? res.data.earlyTimes : 0
          this.listData = res.data ? res.data.records || [] : []

          this.listData.map(cu => {
            let week = [...cu.weekTime.split(',')]
            cu.weekTime = week.map(item => {
              if (item != ',') {
                switch (Number(item)) {
                  case 1:
                    return '一'
                    break
                  case 2:
                    return '二'
                    break
                  case 3:
                    return '三'
                    break
                  case 4:
                    return '四'
                    break
                  case 5:
                    return '五'
                    break
                  case 6:
                    return '六'
                    break
                  case 7:
                    return '日'
                    break
                  default:
                    break
                }
              }
            })
            // console.log(weekTimes)
            // if (cu.entityList && cu.entityList.length > 0) {
            //   // 打卡状态（0. 无效，1.有效）
            //   let temp = cu.entityList.filter(item => { return item.punchCardStatus == 1 }) || []
            //   if (temp && temp.length > 0) {
            //     cu.punchCardStatus = 1
            //   } else {
            //     cu.punchCardStatus = 0
            //   }
            // }
          })
        } else {
          this.$notify(res.msg || '获取打卡记录失败')
        }
      })
    },
    // 时间格式化
    formatter(type, val) {
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      return val
    },
    // 时间选择
    dateConfirm(val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      this.param.month = year + '-' + (month < 10 ? '0' + month : month)
      this.dateShow = false
      this.getList()
    },
    imgFuntion(url) {
      this.overall = url
      this.isOverall = true
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
#clockRecords {
  width: calc(100% - 40px);
  height: calc(100vh - 40px - 44px - 10px);
  padding: 20px;
  overflow: auto;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  &.detail {
    height: 100vh !important;
  }
  .data-top {
    background: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .item {
      width: 50%;
      display: flex;
      flex-direction: column;
      text-align: center;
      margin: 25px 0;
      .item-number {
        color: #333333;
        b {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 10px;
        }
      }
    }
    .item:nth-child(-n + 2) {
      border-right: 1px solid #cccccc;
    }
  }
  .r-time {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .time-length {
      color: #999;
      font-size: 14px;
    }
    .time-div {
      width: 30%;
      height: 30px;
      border-radius: 20px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      color: #333;
      font-size: 16px;
    }
  }
  .r-list {
    padding-bottom: 20px;
    /deep/.van-collapse {
      &-item {
        margin-bottom: 20px;
        .van-cell {
          border-radius: 6px;
          &.van-collapse-item__title--expanded {
            border-radius: 6px 6px 0 0;
          }
          &__title {
            div {
              width: 98%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              span:nth-of-type(1) {
                font-weight: bold;
                font-size: 16px;
              }
              span:nth-of-type(2) {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                &.e {
                  background: #467dff;
                }
                &.une {
                  background: #eb6a4e;
                }
              }
            }
          }
        }
        .van-collapse-item__wrapper {
          border-radius: 0 0 6px 6px;
          .van-collapse-item__content {
            .van-steps {
              &__items {
                .van-step {
                  .time {
                    margin-bottom: 10px;
                    overflow: hidden;
                    span:nth-of-type(1) {
                      margin-right: 10px;
                      font-size: 18px;
                      color: #333333;
                      font-weight: bold;
                      float: left;
                    }
                    span:nth-of-type(2) {
                      padding: 2px 10px;
                      border-radius: 10px;
                      float: left;

                      &.e {
                        border: 1px solid #467dff;
                        color: #467dff;
                      }
                      &.une {
                        border: 1px solid #eb6a4e;
                        color: #eb6a4e;
                      }
                    }
                  }
                  .remark {
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 10px;
                    div {
                      word-wrap: break-word;
                    }
                    img {
                      margin: 10px 0;
                      width: 50px;
                      height: 50px;
                      object-fit: cover;
                    }
                  }
                  .distance {
                    color: #eb6a4e;
                    i {
                      margin-right: 10px;
                    }
                  }
                  .remark_color {
                    margin-top: 10px;
                    color: #467dff;
                    i {
                      margin-right: 10px;
                    }
                  }
                  .address {
                    color: #ccc;
                    i {
                      margin-right: 8px;
                    }
                  }
                  .address-name {
                    margin: 4px 0 6px;
                    color: #ccc;
                  }
                  &--vertical:not(:last-child)::after {
                    border-bottom-width: 0;
                  }
                  &__circle-container {
                    i {
                      display: block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                    }
                  }
                  &.uneStep {
                    .van-step__circle-container {
                      i {
                        background-color: #eb6a4e;
                      }
                    }
                  }
                  &.eStep {
                    .van-step__circle-container {
                      i {
                        background-color: #467dff;
                      }
                    }
                  }
                  &.remark_step {
                    .van-step__circle-container {
                      i {
                        background-color: #467dff;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .situation {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: #000;
    img {
      width: 100%;
      height: 300px;
      margin-top: 50%;
      object-fit: contain;
    }
  }
}
</style>
